<!--
 * @Author: lan.h
 * @Date: 2021-10-25 09:17:15
 * @LastEditors: lan.h
 * @LastEditTime: 2021-11-30 15:49:14
 * @Description: 
-->
<template>
  <div class="main">
    <navigation></navigation>
    <router-view/>
    <footerDIV></footerDIV>
  </div>
</template>

<script>
import navigation from 'mcomponents/navigation.vue'
import footerDIV from 'mcomponents/footer.vue'

export default {
  name: 'Main',
  components: {
    navigation, footerDIV
  }
}
</script>
